import React from 'react';
import BackgroundSelectItem from './BackgroundSelectItem.js';


class DesignerBackgroundSelect extends React.Component {

    constructor(props) {
        super(props);

        this.handleSelect = this.handleSelect.bind(this);
    }

    handleSelect(bg) {
        this.props.onBackgroundSelect(bg);
    }

    render() {

        // no bg select in edit mode
        if (this.props.submitMode == 'edit' || this.props.isDesignerAddonMode)
        {
            return null;
        }


        let perspectiveBackgrounds = this.props.backgrounds.filter((bg) => {
            return bg.perspective_id == this.props.activePerspective.id && bg.perspective_varid == this.props.activePerspective.varid
        });


        let activeBackgroundVar = false;

        if (this.props.activeDesignerVariants !== undefined)
            activeBackgroundVar = this.props.activeDesignerVariants.find( (vr) => { return vr.isBackground == '1' });


        let backgroundTitle = 'Farbe';
        if (activeBackgroundVar)
            backgroundTitle = activeBackgroundVar.title;

        // use all background if var is background and persvar
        if (activeBackgroundVar && activeBackgroundVar.isPersGroup == '1')
        {
            perspectiveBackgrounds = this.props.backgrounds.filter(bg => {
                return bg.perspective_id == this.props.activePerspective.id;
            });
        }

        const backgroundSelects = perspectiveBackgrounds.map((bg) =>
        {
            let active = bg.id == this.props.activeBackground.id;
            // if (activeBackgroundVar && activeBackgroundVar.isPersGroup == '1')
            // {
            //     active = this.props.activePerspective.varid == bg.background_id;
            // }

            return <BackgroundSelectItem
                key={bg.id + '_' + bg.perspective_varid}
                background={bg}
                active={active}
                onBackgroundSelect={this.handleSelect}
            />
        }
        );

        if (this.props.position == 'preview')
        {
            return (
                <div className="designer_preview_background_select">
                    {backgroundSelects}
                </div>
            );
        }
        else if (this.props.position == 'basket')
        {
            return (
                <div className="designer_background_select designer_controll">
                    <div className="designer_controll_title">
                        {backgroundTitle}:
                    </div>
                    <div className="designer_controll_actions">
                        {backgroundSelects}
                    </div>
                </div>
            );
        }
        else
        {
            return (
                <div className="designer_background_select designer_controll row hidden-xl hidden-lg hidden-sm">
                    <div className="designer_controll_title col-sm-2 col-md-1">
                        {backgroundTitle}:
                    </div>
                    <div className="designer_controll_actions col-sm-10 col-md-11">
                        {backgroundSelects}
                    </div>
                    <div style={{clear: 'left'}} />
                </div>
            );
        }
    }
  }
export default DesignerBackgroundSelect;



// WEBPACK FOOTER //
// ./src/DesignerBackgroundSelect.js